import React from 'react'
import { Route } from 'react-router-dom'
import MediaQuery from 'react-responsive'

import logIn from '../../actions/logIn'
import FirebaseAuth from './FirebaseAuth'
import {
  StickyMobileHeader,
  Header,
} from '../../styles/layout'
import {
  AppLogo,
  AppAction,
  InternalLink,
  HeaderButton,
} from '../../styles/links'

const AppHeader = ({showBackButton}) => (
  <Route render={({history}) => ([
    <MediaQuery key='desktop' query="(min-width: 500px)">
      <Header>
        <AppLogo to="/">
          <span role="img" aria-label="heart">💛</span>
          <div>heartstrings</div>
        </AppLogo>

        <div style={{float: 'right'}}>
          <FirebaseAuth>
            { ({isLoading, error, auth}) => {

              if (isLoading) {
                return '...'
              }

              if (error) {
                return '⚠️ error logging in'
              }

              if (!auth) {
                return <AppAction onClick={logIn}>log in</AppAction>
              }

              return <InternalLink to={`/account`}>account</InternalLink>
            }}
          </FirebaseAuth>
        </div>
      </Header>
    </MediaQuery>
    ,
    <MediaQuery key='mobile' query="(max-width: 499px)">
      {showBackButton &&
        <StickyMobileHeader>
          <HeaderButton onClick={() => history.push('/')}>
            <ion-icon name="arrow-back"></ion-icon>
          </HeaderButton>
        </StickyMobileHeader>
      }
    </MediaQuery>
  ])} />
)

export default AppHeader



// WEBPACK FOOTER //
// ./src/views/misc/AppHeader.js